import React from 'react'
import Wishlistdash from '../Components/User-Dashboard/Wishlistdash';
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'

function Wishlistdashboardpage() {
    return (
        <>
        <Combaintop/>
        <Wishlistdash/>
        <Combainbottom/>
        </>
        
    )
}

export default Wishlistdashboardpage
